import Button from "components/foundation/Button";
import Select from "components/foundation/Select/Select";
import CardLayout from "components/foundation/templates/CardLayout";
import styled, { css } from "styled-components";

export const CardLayoutStyle = styled(CardLayout.Container)``;

export const SignUpFormStyle = styled.form`
  display: flex;
  flex-direction: column;
  gap: 3.4rem;
`;

export const DuplicateCheckButton = styled(Button)`
  height: 5rem;

  ${({ theme }) => css`
    ${theme.media.small} {
      height: 4.4rem;
    }
  `}
`;

export const SignUpFormActions = styled.div`
  ${({ theme }) => css`
    ${theme.media.small} {
      margin-top: 1.4rem;
    }
  `}
`;

export const PhoneSelect = styled(Select)`
  width: 14rem;
`;
